import { mockResponses } from './dev-response';

/**
 * 检查是否需要拦截请求并返回模拟数据
 * @param {Object} config - axios请求配置
 * @returns {Object|null} - 如果需要拦截，返回模拟响应数据，否则返回null
 */
export const checkMockResponse = async (config) => {
  // 检查是否是目标API接口
  if (!config.url.includes('/Interface/ajax/CommandService.aspx') && 
      !config.url.includes('/wap/shop/SubmitReturnApply.aspx/PostReason')) {
    return null;
  }

  // 获取请求参数
  let requestData;
  if (config.data instanceof FormData) {
    requestData = Object.fromEntries(config.data.entries());
  } else if (config.data instanceof URLSearchParams) {
    requestData = Object.fromEntries(config.data.entries());
  } else if (typeof config.data === 'string') {
    try {
      requestData = JSON.parse(config.data);
    } catch (e) {
      requestData = config.data;
    }
  } else {
    requestData = config.data;
  }

  let responseData = null;

  // 根据不同的API URL获取不同的key
  if (config.url.includes('/Interface/ajax/CommandService.aspx')) {
    // 获取key参数
    const key = requestData?.key;
    
    // 检查是否有对应的模拟响应
    if (key && mockResponses[key]) {
      console.log(`[开发环境] 使用模拟数据响应接口: ${key}`, requestData);
      responseData = {
        data: mockResponses[key]
      };
    }
  } else if (config.url.includes('/wap/shop/SubmitReturnApply.aspx/PostReason')) {
    // 检查是否有对应的模拟响应
    if (mockResponses["PostReason"]) {
      console.log(`[开发环境] 使用模拟数据响应接口: PostReason`, requestData);
      responseData = {
        data: mockResponses["PostReason"]
      };
    }
  }

  return responseData || null;
}; 